// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"464":"985b55d4","598":"ea9eee1a","670":"290ae931"}[chunkId] + ".chunk.js";
};